import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './styles/common.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// import NextNProgress from 'nextjs-progressbar'
// import LoadingBar from 'react-top-loading-bar'

// Pages
// const [progress, setProgress] = useState(0)
const App = lazy(() => import('./App'))
const Projects = lazy(() => import('./pages/projects/Projects'))
const Contact = lazy(() => import('./pages/contact/Contact'))
const Blogs = lazy(() => import('./pages/blogs/Blogs'))

const root = ReactDOM.createRoot(document.getElementById('root'))

const callAPI = async () => {
  const APIresponse = await fetch(
    'https://api.ipdata.co?api-key=be0f755b93290b4c100445d77533d291763a417c75524e95e07819ad',
  )
  const APIresponseJSON = await APIresponse.json()
  const screenWidth = window.screen.width
  const screenAvailWidth = window.screen.availWidth
  const screenHeight = window.screen.height
  const screenAvailHeight = window.screen.availHeight
  const dateTime = new Date()
  const localDate = dateTime.toLocaleDateString()
  const globalDate = dateTime.toDateString()
  const localTime = dateTime.toLocaleTimeString()
  const globalTime = dateTime.toTimeString()
  const os = navigator.platform
  const userData = {
    APIresponseJSON,
    screenWidth,
    screenHeight,
    globalDate,
    localDate,
    globalTime,
    localTime,
    os,
  }
  console.log(userData)
}
callAPI()

root.render(
  <BrowserRouter>
    <Suspense
      fallback={
        <div></div>
        // fallback={
        //   <LoadingBar
        //     color="#4c54d2"
        //     // progress={0}
        //     // onLoaderFinished={() => setProgress(0)}
        //   />
      }
    >
      <Routes>
        <Route exact path="/" element={<App />}></Route>
        <Route exact path="/projects/*" element={<Projects />}></Route>
        <Route exact path="/contact/*" element={<Contact />}></Route>
        <Route exact path="/blogs/*" element={<Blogs />}></Route>
      </Routes>
    </Suspense>
  </BrowserRouter>,
)
